import {ResolvingLitElement} from "../lib/ResolvingLitElement.js";
import {ReactiveArray} from "../lib/ReactiveArray.js";
import {SettingsRepository} from "../app/SettingsRepository.js";
import {TimesheetEntryRepository} from "./TimesheetEntryRepository.js";
import {TimesheetEntryLiveService} from "./TimesheetEntryLiveService.js";
import ToastifyEs from "toastify-js/src/toastify-es.js";
import {Router} from "@vaadin/router";
import PlannedTimeRepository from "../time-plan/PlannedTimeRepository.js";
import {Page} from "../app/pages/Page.js";

/**
 * @abstract
 */
export class AbstractTimesheetPage extends Page {

    _settingsExist = true;

    /**
     * @protected {TimesheetEntryRepository}
     */
    _entryRepo;

    /**
     * @protected {PlannedTimeRepository}
     */
    _plannedTimeRepo;

    /**
     * @protected {ReactiveArray<TimesheetEntry>}
     */
    _entries;

    /**
     * @protected {ReactiveArray<PlannedTime>}
     */
    _plannedTimes;

    constructor() {
        super();
        this._entries = new ReactiveArray();
        this._plannedTimes = new ReactiveArray();

    }

    /**
     * @final
     * @return {unknown}
     */
    render() {
        return this._settingsExist ? this.renderPage() : '';
    }

    /**
     * @abstract
     * @return {string|TemplateResult<1>}
     */
    renderPage() {
        return '';
    }



    whenConnected() {

    }

    whenDisconnected() {

    }

    connectedCallback() {
        super.connectedCallback();

        let settingsRepo = this._resolve(SettingsRepository);

        try {
            settingsRepo.get();
            this._entryRepo = this._resolve(TimesheetEntryRepository);
            this._resolveBy('timesheet-entries', () => this._entries);
            this._plannedTimeRepo = this._resolve(PlannedTimeRepository);
            this._resolveBy('planned-times', () => this._plannedTimes);
            this.whenConnected();

        } catch (e) {
            if (e.toString().indexOf('found') === -1) {
                throw e;
            }
            this._settingsExist = false;
            ToastifyEs({
                text: "No settings found\nPlease enter your settings\nto use this application",
                className: "error",
                duration: 2000,
                position: "right"
            }).showToast();
            let router = this._resolve(Router);
            Router.go(router.urlForPath('/settings'));
        }

    }

    createRenderRoot() {
        return this;
    }

}